<template lang="pug">
  menu-item(:label=`$t('cas')`)
    menu-item(:label=`$t('sql_editor')`, v-model="module.showSqlEditor", keybind="shift+Q")
    menu-item(:label=`$t('job_list')`, v-model="module.showJobList")
</template>


<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { CasModule } from "@/modules/ssp_database/CasModule";

@Component
export default class extends Vue {
  @Prop({ required: true })
  module!: CasModule
}
</script>

<i18n>
en:
  cas: CAS
  sql_editor: SQL Editor
  job_list: Job List
ja:
  cas: CAS
  sql_editor: SQLエディター
  job_list: ジョブ一覧

</i18n>